<template>
	<div @mouseleave="closeTile" class="iv2__color-changer d-none d-xl-flex align-items-center">
		<div @mouseover="openTile" class="iv2__color-changer--arrow rounded-left"><i class="fas fa-caret-left size-38 mt-2"></i></div>
		<ul class="iv2__color-changer--block list-unstyled m-0" :class="{active: activeColor}">
			<li v-for="colors in $t('color')" :key="colors.id" @click="changer(colors.code)" class="iv2__color-changer--list">
				<span class="iv2__color-changer--tile" :class="'theme__scheme-' + colors.code"></span>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeColor: false,
		}
	},

	methods: {
		openTile() {
			this.activeColor = true;
        },
        
		closeTile() {
			this.activeColor = false;
		},

		changer(val) {
			document.body.className = '';
			document.body.className = 'theme-a__' + val;
		}
	}
}
</script>

<style lang="scss">
	.iv2__color-changer {
		position: fixed;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		z-index: 111111;

		.iv2__color-changer--arrow {
			background-color: rgba(0, 0, 0, 0.8);
			color: #fff;
			width: 20px;
			padding-left: 3px;
		}

		.iv2__color-changer--block {
			background-color: rgba(0, 0, 0, 0.8);
			width: 0px;
			height: 100%;
			transition: .3s;

			&.active {
				width: 60px;
			}

			.iv2__color-changer--list {
				background-color: #fff;
				margin: 13px;
				padding: 1px;

				.iv2__color-changer--tile {
					display: block;
					margin: 1px;
					width: 30px;
					height: 30px;
					cursor: pointer;
				}
			}
		}
	}
</style>